module.exports = __webpack_public_path__ + "img/csr_swiper_04_07.2cb94645.jpg";